<template>
  <HeaderPopup v-bind:onCloseClick="onCloseClick">
    <div class="dev-config-block">
      <div class="block">
        <div class="tabs">
          <Tab :active="isSportsActive" :onClick="onSportsClick">Sport</Tab>
          <Tab :active="isWidgetsActive" :onClick="onCasinoClick">Widgets</Tab>
        </div>
      </div>
      <div class="block" v-if="isSportsActive">
        <div class="title">Routing</div>
        <HeaderSelector
          :options="ROUTING_OPTIONS"
          :value="routing"
          :onChange="changeRouting"
        />
      </div>
      <div class="toggle-block" v-if="isSportsActive">
        <div class="title">Add fixed footer</div>
        <Toggle
          :checked="showBottomPanel"
          :onChange="toggleBetSlipOffsetBottom"
        />
      </div>
      <div class="block" v-if="showThemesBranches">
        <div class="title">Themes Branches</div>
        <HeaderSelector
          :options="themesBranches"
          :value="selectedThemesBranch"
          :onChange="changeThemesBranch"
        />
      </div>
      <div class="block" v-if="showBranches">
        <div class="title">Branch</div>
        <HeaderSelector
          :options="branches"
          :value="selectedBranch"
          :onChange="changeBranch"
          searchable
        />
      </div>
      <div class="block" v-if="showEnvs">
        <div class="title">Environment</div>
        <HeaderSelector
          :options="envs.map((env) => env.name)"
          :value="activeEnv.name"
          :onChange="changeEnv"
          searchable
        />
      </div>
      <div class="block">
        <div class="title">Brand ID</div>
        <HeaderSelector
          :options="brands"
          :value="activeBrand"
          :onChange="changeBrandId"
          searchable
        />
      </div>
      <div class="block">
        <UserMenu :closePopup="onCloseClick" />
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
import { mapState } from "vuex";
import HeaderPopup from "./HeaderPopup";
import HeaderSelector from "../HeaderSelector";
import UserMenu from "../UserMenu";
import Tab from "../Tab";
import Toggle from "../Toggle";
import { ROUTING_OPTIONS } from "../../store/modules/app";
import QUERY_PARAMS from "../../constants/queryParams";

export default {
  name: "DevConfigBlock",
  components: {
    HeaderPopup,
    HeaderSelector,
    Tab,
    UserMenu,
    Toggle,
  },
  props: {
    onCloseClick: Function,
  },
  data() {
    return {
      ROUTING_OPTIONS,
    };
  },
  computed: {
    ...mapState("app", [
      "selectedThemesBranch",
      "selectedBranch",
      "activeBrand",
      "activeEnv",
      "themesBranches",
      "branches",
      "brands",
      "envs",
      "routing",
      "showBottomPanel",
    ]),
    showThemesBranches() {
      return !process.env.PRESENTATION;
    },
    showBranches() {
      return process.env.ENV === "dev";
    },
    showEnvs() {
      return !process.env.PRESENTATION;
    },
    isWidgetsActive() {
      return this.$route.path === "/casino";
    },
    isSportsActive() {
      return this.$route.path.startsWith("/sportsbook");
    },
  },
  methods: {
    changeEnv(envName) {
      const {
        [QUERY_PARAMS.ENVIRONMENT_NAME]: environmentNameParam,
        [QUERY_PARAMS.BRAND_ID]: brandIdParam,
        ...query
      } = this.$route.query;

      if (environmentNameParam || brandIdParam) this.$router.replace({ query });

      this.$store.dispatch(
        "app/setEnv",
        this.envs.find((env) => env.name === envName)
      );
    },
    changeThemesBranch(branch) {
      this.$store.dispatch("app/setThemesBranch", branch);
    },
    changeBranch(branch) {
      const { [QUERY_PARAMS.BRANCH_NAME]: branchParam, ...query } =
        this.$route.query;

      if (branchParam) this.$router.replace({ query });

      this.$store.dispatch("app/setBranch", branch);
    },
    changeBrandId(brandId) {
      const { [QUERY_PARAMS.BRAND_ID]: brandIdParam, ...query } =
        this.$route.query;

      if (brandIdParam) this.$router.replace({ query });

      this.$store.dispatch("app/setBrand", brandId);
    },
    onCasinoClick() {
      this.onCloseClick();
      this.$router.push("/casino");
    },
    onSportsClick() {
      this.onCloseClick();
      this.$router.push("/sportsbook");
    },
    changeRouting(value) {
      this.$store.dispatch("app/setRouting", value);
    },
    toggleBetSlipOffsetBottom(value) {
      this.$store.dispatch("app/toggleBetSlipOffsetBottom", value);
    },
  },
};
</script>

<style scoped>
.dev-config-block {
  padding: 32px 16px 24px;
}
.toggle-block {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.block {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.block:last-of-type {
  margin-bottom: 0;
}
.block:last-of-type {
  padding-bottom: 0;
}
.title {
  font-size: 12px;
  line-height: 1.5;
  font-weight: 600;
  margin: 0 0 8px 8px;
  color: #3b4c58;
}
.tabs {
  display: flex;
  background: rgba(142, 152, 157, 0.2);
  height: 32px;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
